<template>
  <div class="development" id="development">
    <el-row>
      <el-col class="dev_left">
        <img :src="basic.us_course_image" alt />
      </el-col>
      <el-col class="dev_right">
        <h2>发展历程</h2>
        <p class="underline"></p>
        <p class="dev-p">Development path</p>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      basic: {}
    };
  },
  created() {
    this.basic = this.$cache.get("aboutConfig");
  }
};
</script>
<style lang="less" scoped>
.development {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  margin-top: 36px;
  .el-row {
    display: flex;
    height: 441px;
    align-items: center;

    .dev_left {
      font-size: 0;
      width: 850px;
      height: 344px;
      margin-left: 48px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .dev_right {
      width: 305px;
      min-width: 305px;
      padding: 48px;
      h2 {
        font-size: 30px;
        font-weight: 500;
        color: #333;
      }
      .underline {
        width: 24px;
        height: 2px;
        background: #e60616;
        margin: 36px 0 41px;
      }
      .dev-p {
        font-size: 24px;
        color: #999999;
      }
    }
  }
}
</style>



